import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

export const OperatorNotNode = ({ data, notNode = false, onDataChange }) => {
    const handleValueChange = (newDrop) => onDataChange({ valueDrop: newDrop });

    return (
        <div className="node-operator-not" style={{
            display: 'flex',
            flexDirection: (data?.layout || 'vertical') === 'vertical' ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '100%'
        }}>
            <div style={{
                background: operatorColors['Negação/complementação'] || operatorColors['Menor que'],
                color: 'white',
                borderRadius: '8px',
                padding: '6px 8px',
                fontWeight: 'bold',
                fontSize: '16px',
                width: '52px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '2px',
                    lineHeight: 1
                }}>
                    <img
                        src="/images/icons/nao.png"
                        alt=""
                        aria-hidden="true"
                        style={{ width: '22px', height: '14px', objectFit: 'contain', display: 'block' }}
                    />
                    <span style={{ fontSize: '10px', fontWeight: 800 }}>NÃO</span>
                </div>
            </div>
            <CustomInputDrop dropData={data.valueDrop || { id: 'value', type: null, data: {} }} dropId="value" onDropChange={handleValueChange} />
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};
